const semanticTokens = {
  colors: {
    divider: {
      'default': 'blackAlpha.200',
      _dark: 'rgba(255, 160, 28, 0.16)',
    },
    text: {
      'default': 'blackAlpha.800',
      _dark: 'whiteAlpha.800',
    },
    text_secondary: {
      'default': 'gray.500',
      _dark: 'gray.400',
    },
    link: {
      'default': 'elvor.600',
      _dark: 'elvor.300',
    },
    link_hovered: {
      'default': 'elvor.500',
      _dark: 'elvor.200',
    },
    icon_link_external: {
      'default': 'gray.300',
      _dark: 'gray.500',
    },
    icon_info: {
      'default': 'gray.400',
      _dark: 'gray.500',
    },
    error: {
      'default': 'red.500',
      _dark: 'red.500',
    },
    dialog_bg: {
      'default': 'white',
      _dark: 'rgba(12, 7, 4, 0.96)',
    },
    glass_bg: {
      'default': 'white',
      _dark: 'rgba(255, 166, 45, 0.055)',
    },
    glass_border: {
      'default': 'blackAlpha.100',
      _dark: 'rgba(255, 185, 54, 0.22)',
    },
  },
  shadows: {
    action_bar: '0 4px 4px -4px rgb(0 0 0 / 10%), 0 2px 4px -4px rgb(0 0 0 / 6%)',
    elvor_glow: '0 0 0 1px rgba(255, 185, 54, 0.18), 0 18px 54px rgba(255, 122, 26, 0.20), 0 0 80px rgba(255, 159, 28, 0.10)',
    elvor_button: '0 12px 34px rgba(255, 122, 26, 0.34), 0 0 24px rgba(255, 185, 54, 0.22)',
  },
};

export default semanticTokens;
